// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"611befa3","639":"3e9d06c7"}[chunkId] + ".chunk.js";
};